import { gql, useQuery } from "@apollo/client";
import { ProtocolItem } from "../../types";
import { useFeatureFlags } from "../../context/FeatureFlagsContext";

interface ProtocolsQueryResponse {
  data: ProtocolItem[];
  cursor: string;
}

const query = gql`
  query protocols {
    # TODO: handle pagination properly
    protocols(count: 2000) {
      data {
        id
        name
        description
        status
        visibleToClinics {
          id
          name
        }
      }
    }
  }
`;

const allProtocolsQuery = gql`
  query allProtocols {
    # TODO: handle pagination properly
    protocols: allProtocols(count: 2000) {
      data {
        id
        name
        description
        status
        visibleToClinics {
          id
          name
        }
      }
    }
  }
`;

export function useProtocols() {
  const { featureFlags } = useFeatureFlags();

  const shouldUseAllProtocols = featureFlags.ENABLE_MANAGE_COURSES;

  return useQuery<{ protocols: ProtocolsQueryResponse }>(
    shouldUseAllProtocols ? allProtocolsQuery : query,
  );
}
